import { AnalyticsError, ErrorCodes } from './errors';
import { PlaybackBaseEventData } from './playback-base-event-data';

export enum OverlayAction {
  subtitleChange = 'SUB_CHANGE',
  audioChange = 'AUDIO_CHANGE',
  videoBitrateChange = 'VIDEO_BITRATE_CHANGE',
  nextEpisode = 'NEXT_EP',
  skipIntro = 'SKIP_INTRO',
  hijacked = 'HIJACKED',
  reachedConcurrencyHhLimit = 'CONCURRENCY_HH',
  reachedConcurrencyContentRuleLimit = 'CONCURRENCY_CN',
  geoBlock = 'GEO_BLOCK',
}

function validatePlaybackOverlayArguments(data: PlaybackOverlayEventArgs) {
  switch (data.overlayAction) {
    case OverlayAction.subtitleChange:
    case OverlayAction.audioChange:
      if (!data.languageId) {
        throw new AnalyticsError(ErrorCodes.subtitleIdMissing);
      }
      break;
    case OverlayAction.reachedConcurrencyHhLimit:
    case OverlayAction.reachedConcurrencyContentRuleLimit:
    case OverlayAction.geoBlock:
      if (!data.errorCode) {
        throw new AnalyticsError(ErrorCodes.errorIdMissing);
      }
      break;
  }
}

export class PlaybackOverlayEventArgs extends PlaybackBaseEventData {
  readonly overlayAction: OverlayAction;
  readonly languageId?: string;
  readonly errorCode?: string;

  constructor(data: PlaybackOverlayEventArgs) {
    super('playbackOverlay', data as PlaybackBaseEventData);
    this.overlayAction = data.overlayAction;
    this.languageId = data.languageId;
    this.errorCode = data.errorCode;
    validatePlaybackOverlayArguments(this);
  }
}
